// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"styles_subtitle__1Mcqe","cards-container":"styles_cards-container__P9rt2","force-wrap":"styles_force-wrap__3hppM"};